/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Image as ImageIcon, Check } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';

/** Passo 2 — upload del logo. */
export const StepLogo = ({ preview, uploaded, onFile }) => (
  <div className="space-y-4 animate-fade-slide" data-testid="setup-panel-logo">
    <div>
      <h2 className="font-display font-semibold text-lg flex items-center gap-2"><ImageIcon className="h-5 w-5 text-primary" /> Logo della clinica</h2>
      <p className="text-sm text-muted-foreground">PNG, JPEG, WebP o SVG fino a 1 MB. Sostituisce il logo in header, login e PDF.</p>
    </div>
    <div className="grid gap-4 sm:grid-cols-[200px_1fr] items-center">
      <div className="h-32 rounded-xl border border-dashed border-border bg-muted/30 flex items-center justify-center overflow-hidden">
        {preview ? <img src={preview} alt="Anteprima logo" className="max-h-28 max-w-[180px] object-contain" /> : <span className="text-xs text-muted-foreground">Anteprima</span>}
      </div>
      <div className="space-y-2">
        <Input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" onChange={(e) => onFile(e.target.files?.[0])} className="h-11 rounded-xl pt-2" data-testid="setup-logo-file" />
        {uploaded && <Badge variant="success" className="text-[10px]"><Check className="h-3 w-3 mr-1" /> caricato</Badge>}
        <p className="text-[11px] text-muted-foreground">Facoltativo: puoi saltare e caricarlo dopo da Amministrazione → Brand.</p>
      </div>
    </div>
  </div>
);
